import BadgeText from './BadgeText'

export default BadgeText
